import React from 'react';
import PropTypes from 'prop-types';

const DailyReportTipRow = ({tip}) => {
  return (
    <React.Fragment key={tip.id}>
      <div>{tip.to}</div>
      <div>{tip.amount}</div>
    </React.Fragment>
  );
};

DailyReportTipRow.propTypes = {
  tip : PropTypes.object.isRequired
};

export default DailyReportTipRow;
